module.exports = __webpack_public_path__ + "static/media/jxcs.bf9f0aad.mp4";